import React from "react";

import SectionContainer from "core/SectionContainer";
import CardsTwoUp from "core/CardsTwoUp";
import OurCustomers from "./OurCustomers";

import {
    MarketingPageSectionHeadingContainer,
    MarketingPageSectionEyebrowSubheading,
    MarketingPageSectionHeading,
    MarketingPageSectionBiLine
} from "core/MarketingPageSectionHeading";
import { BorderBottomLink } from "core/Typography";
import { PageAnchor } from "./styles";

import { heroCardData, apiCards } from "./data";
import { apiMarketingPagePath } from "data/links";

const IconApiSection = () => (
    <PageAnchor id={heroCardData[2].sectionId}>
        <SectionContainer>
            <MarketingPageSectionHeadingContainer>
                <MarketingPageSectionEyebrowSubheading>
                    Noun Project
                </MarketingPageSectionEyebrowSubheading>
                <MarketingPageSectionHeading
                    type="h2"
                    size="xl"
                    alignment="center"
                >
                    Icon API Plans and Pricing
                </MarketingPageSectionHeading>
                <MarketingPageSectionBiLine>
                    With our Icon API, developers can bring more than 3 million
                    high-quality SVG and PNG icons to any technology that they
                    create.{" "}
                    <BorderBottomLink href={apiMarketingPagePath}>
                        Learn more about the Noun Project Icon API.
                    </BorderBottomLink>
                </MarketingPageSectionBiLine>
            </MarketingPageSectionHeadingContainer>
            <OurCustomers />

            <CardsTwoUp cards={apiCards} cardBoxesAlignment="center" />
        </SectionContainer>
    </PageAnchor>
);

export default IconApiSection;
